<template>
    <h2>details</h2>
</template>
<script>
export default{

}
</script>
